import styled from 'styled-components';

export const PageTitle = styled.h2`
`;